import { render, staticRenderFns } from "./Eraser.vue?vue&type=template&id=7adfc59c&scoped=true&"
import script from "./Eraser.vue?vue&type=script&lang=ts&"
export * from "./Eraser.vue?vue&type=script&lang=ts&"
import style0 from "./Eraser.vue?vue&type=style&index=0&id=7adfc59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adfc59c",
  null
  
)

export default component.exports